export default {
  regular: {
    fontFamily: 'Nunito',
  },
  medium: {
    fontFamily: 'Nunito',
  },
  light: {
    fontFamily: 'Nunito',
  },
  thin: {
    fontFamily: 'Nunito',
  },
}

